/**
 * Texto de erro das ações da aba "Meus Estudos" (Reenviar, Cancelar e Excluir, #1994).
 *
 * O backend põe detalhes técnicos no `message` dos erros 500 ("Erro interno do servidor.\n\n[...]",
 * `language/pt-br/base.json` do wsgi-beta) e a rede devolve "TypeError: Failed to fetch": nenhum
 * dos dois vai para a tela. Os erros de negócio (404, 409, 422) trazem um texto feito para o
 * usuário e são mostrados como vêm.
 */

import type { ResponseError } from 'services/api/base';

const CONNECTION_STATUSES = ['FETCH_ERROR', 'PARSING_ERROR', 'TIMEOUT_ERROR'];

export const CONNECTION_ERROR_MESSAGE = 'Não foi possível falar com o servidor. Verifique a conexão e tente de novo.';

/**
 * @param error - Erro da mutation, no formato do baseQuery (`ResponseError`).
 * @param fallback - Texto da ação para erro interno ou desconhecido (ex.: "Não foi possível
 *   reenviar o estudo. Tente novamente em instantes.").
 * @returns O texto a mostrar.
 */
export function myStudyActionErrorMessage(error: unknown, fallback: string): string {
  const { status, data, description } = (error ?? {}) as Partial<ResponseError>;
  if (typeof status === 'string') {
    return CONNECTION_STATUSES.includes(status) ? CONNECTION_ERROR_MESSAGE : fallback;
  }
  if (typeof status !== 'number' || status >= 500) return fallback;
  return description || data || fallback;
}
